import React from 'react';
import styled from 'styled-components';

export const ChartMessageContainer = styled(
  ({ hasMessageText, ...props }: any) => <div {...props} />,
)`
  margin-bottom: 0px;
  position: relative;
  border-radius: 4px;
  line-height: 0;
  border-bottom-left-radius: ${({ hasMessageText }) =>
    hasMessageText ? '0' : '4px'};
  border-bottom-right-radius: ${({ hasMessageText }) =>
    hasMessageText ? '0' : '4px'};
`;
export const ChartImage = styled.img`
  width: 100%;
  border-radius: 4px;
`;

export const ChartDescription = styled.div`
  width: 100%;
  background-color: #f2f5fc;
  padding: 8px 12px;
`;

export const ChartName: any = styled.div`
  font-size: 14px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  color: #8a94bd;
  border-bottom-left-radius: ${({ hasMessageText }: any) =>
    hasMessageText ? '0' : '4px'};
  border-bottom-right-radius: ${({ hasMessageText }: any) =>
    hasMessageText ? '0' : '4px'};
  cursor: pointer;
`;

export const DateRange = styled.div`
  text-align: center;
  position: absolute;
  line-height: normal;
  right: 0;
  top: 0;
  background-color: #f2f5fc;
  border-top-right-radius: 4px;
  font-size: 10px;
  font-weight: 500;
  padding: 4px 6px;
  color: #8a94bd;
`;
